'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$getPrototypeOf = _interopDefault(require('babel-runtime/core-js/object/get-prototype-of'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));
var _possibleConstructorReturn = _interopDefault(require('babel-runtime/helpers/possibleConstructorReturn'));
var _get = _interopDefault(require('babel-runtime/helpers/get'));
var _inherits = _interopDefault(require('babel-runtime/helpers/inherits'));
var $ = _interopDefault(require('jquery'));
var A11y = _interopDefault(require('../global/a11y-helpers.js'));
var Analytics = _interopDefault(require('../global/analytics.js'));
var utils_js = require('../helpers/utils.js');
var AjaxEmailForm = _interopDefault(require('./ajax-email-form.js'));
var FormsAPI = _interopDefault(require('./forms-api.js'));
var signupTracker = _interopDefault(require('./signup/signup-tracker.js'));

/* global fbq */

var Subscribe = function (_AjaxEmailForm) {
  _inherits(Subscribe, _AjaxEmailForm);

  function Subscribe(block, options) {
    _classCallCheck(this, Subscribe);

    var $block = utils_js.isJquery(block) ? block : $(block);
    var $form = $block.find('.subscribe__form');

    var _this = _possibleConstructorReturn(this, (Subscribe.__proto__ || _Object$getPrototypeOf(Subscribe)).call(this, $form, options));

    _this.$block = $block;
    _this.$emailField = _this.$block.find('[name="email"]');
    _this.$content = _this.$block.find('.subscribe__content');
    _this.$successMessage = _this.$block.find('.subscribe__success');
    return _this;
  }

  _createClass(Subscribe, [{
    key: 'displaySuccess',
    value: function displaySuccess() {
      this.$block.addClass('js-success');
      this.$successMessage.attr('aria-hidden', false);
      this.$content.attr('aria-hidden', true);
      A11y.prototype.pageLinkFocus(this.$successMessage);
    }
  }, {
    key: 'trackSuccess',
    value: function trackSuccess() {
      _get(Subscribe.prototype.__proto__ || _Object$getPrototypeOf(Subscribe.prototype), 'trackSuccess', this).call(this);

      var gaCategory = this.$form.data('gaCategory') || 'blog';
      var gaAction = this.$form.data('gaAction') || 'subscription';
      var fbqEvent = this.$form.data('fbqEvent');
      var email = this.$emailField.val();

      Analytics.track(gaCategory, gaAction, 'email');

      if (fbqEvent && typeof window.fbq !== 'undefined') {
        fbq('trackCustom', fbqEvent);
      }

      if (this.$block.parent('.modal').length) {
        Analytics.track(gaCategory, gaAction, 'modalSubmit');
      }

      if (window.optimizely && $.isFunction(window.optimizely.push)) {
        window.optimizely.push({
          type: 'event',
          eventName: 'EmailSubscribe'
        });
      }

      if (FormsAPI.isCustomEmail(email)) {
        return signupTracker.onCustomEmail(true);
      }

      // consistent return, signupTracker returns a resolved deferred
      return $.Deferred().resolve();
    }
  }]);

  return Subscribe;
}(AjaxEmailForm);

module.exports = Subscribe;
